/* BL4CKOUT: keep touch scrolling inside the open cart drawer on iPhone.
   iOS Safari ignores overflow:hidden on the page, so a swipe that starts on a part of the drawer that
   does not scroll (header, free shipping bar), or that reaches the top or bottom of the cart, used to
   drag the page behind it: the pull-to-refresh bounce, after which the cart stopped scrolling.
   Only active while the cart drawer is open; vertical swipes only, so horizontal sliders still work. */
(function () {
  var startX = 0, startY = 0;
  function openDrawer() { return document.querySelector('dialog.cart-drawer__dialog[open]'); }
  document.addEventListener('touchstart', function (e) {
    if (!e.touches || e.touches.length !== 1) return;
    startX = e.touches[0].clientX; startY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    var dialog = openDrawer();
    if (!dialog || !e.touches || e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - startX, dy = e.touches[0].clientY - startY;
    if (Math.abs(dx) > Math.abs(dy)) return; // horizontal swipe: leave it alone
    var target = e.target;
    if (!dialog.contains(target)) { if (e.cancelable) e.preventDefault(); return; } // page behind
    var scroller = target.closest ? target.closest('.cart-drawer__content') : null;
    if (!scroller || !dialog.contains(scroller)) { if (e.cancelable) e.preventDefault(); return; } // fixed part
    var atTop = scroller.scrollTop <= 0;
    var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
    var noScroll = scroller.scrollHeight <= scroller.clientHeight;
    if (noScroll || (atTop && dy > 0) || (atBottom && dy < 0)) { if (e.cancelable) e.preventDefault(); }
  }, { passive: false });
})();
